<ds-overview-section
  [loading]="claimsLoading"
  [spinnerTextPath]="'overview.claims.spinnerText'"
  [sectionHeadingPath]="'overview.claims.sectionHeading'"
>
  @if (!claimsLoading) {
    <ds-overview-section-content>
      <div class="row borderless tiles" data-cy="claimOverviewTilesContainer">
        @for (claim of claimCardData; track claim) {
          <div class="column pad-bottom twelve md-four --claims">
            <ds-tile class="claims-tile" data-cy="claimOverviewTile">
              <div class="tile-heading" tile-heading>
                <div class="heading-icon"><span class="icon-claims2"></span></div>
                <div class="heading-text">
                  <p class="heading-text-nickname">
                    <span dsContent [contentPath]="'overview.claims.claim'"></span>:
                    {{ claim.formattedClaimNumber }}
                  </p>
                  <p class="heading-text-subheading">
                    {{ claim.fullRiskName }}
                  </p>
                </div>
              </div>
              <div class="tile-content" tile-content>
                <div class="row flex">
                  <span class="icon-info icon-info-container"></span>
                  <span
                    ><span dsContent [contentPath]="'overview.claims.latestActivity'"></span>
                    {{ claim.latestActivity.date | dateFormat }}</span
                  >
                </div>
                <div class="row margin-top-5">{{ claim.latestActivity.message }}</div>
              </div>
              <div tile-cta class="tile-cta">
                <button
                  ds-button
                  class="-outline-white"
                  [dsAnalyticsClick]="viewClaimAnalytics.link"
                  [dsRouterLink]="[
                    '/claims/dynamic-fnol-detail/claim-risk-selection/' + claim.claimNumber
                  ]"
                  data-cy="claimOverviewDetailButton"
                  aria-label="View Claim"
                  [disabled]="(impersonating$ | async) == false"
                  dsContent
                  [contentPath]="'overview.claims.viewClaim'"
                ></button>
              </div>
            </ds-tile>
          </div>
        }
      </div>
    </ds-overview-section-content>
  }
</ds-overview-section>
